/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import { MainModalDown, ModalDownContent } from './styles'
import { IoIosCloseCircle } from 'react-icons/io'
import { ImWindows } from 'react-icons/im'
import { GrWindows } from 'react-icons/gr'
import Gid from '../../../assets/icons/Gid.png'
import api from '../../../services/axios'

interface Props {
  closeModal: () => void
}

export default function ModalDownload({ closeModal }: Props) {
  const [isUnlocked, setIsUnlocked] = useState(false)
  const [tokenInput, setTokenInput] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  const handleVerifyToken = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!tokenInput.trim()) {
      setErrorMsg('Por favor, cole o token de acesso.')
      return
    }

    setIsLoading(true)
    setErrorMsg('')

    try {
      // Substitua pela URL base da sua API
      const response = await api.get('/users/me', {
        headers: {
          Authorization: `Bearer ${tokenInput.trim()}`,
          'Content-Type': 'application/json',
        },
      })

      if (response.status !== 200) {
        throw new Error('Token inválido ou expirado.')
      }

      const data = response.data

      if (data?.user?.role === 'administrador') {
        setIsUnlocked(true)
      } else {
        throw new Error('Acesso negado: Apenas administradores podem fazer o download.')
      }
    } catch (error: any) {
      setErrorMsg(error.message || 'Ocorreu um erro ao validar o token.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <MainModalDown>
      <ModalDownContent>
        <button className='close-btn' onClick={closeModal} title='Fechar'>
          <IoIosCloseCircle />
        </button>

        <h1>Download integrador GSA</h1>

        {!isUnlocked ? (
          // --- TELA DE INSERÇÃO DO TOKEN ---
          <div className='unlock-section' style={{ textAlign: 'center', padding: '20px' }}>
            <p>Insira o Token de Administrador para liberar os downloads.</p>

            <form onSubmit={handleVerifyToken}>
              <input
                type='password' // Mantém o token mascarado visualmente
                placeholder='Cole seu Bearer Token aqui'
                value={tokenInput}
                onChange={(e) => setTokenInput(e.target.value)}
                style={{
                  width: '80%',
                  padding: '10px',
                  marginTop: '10px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                }}
              />
              <div style={{ marginTop: '15px' }}>
                <button
                  type='submit'
                  disabled={isLoading}
                  style={{ padding: '10px 20px', cursor: 'pointer' }}
                >
                  {isLoading ? 'Validando...' : 'Acessar'}
                </button>
              </div>
            </form>

            {errorMsg && <p style={{ color: 'red', marginTop: '15px' }}>{errorMsg}</p>}
          </div>
        ) : (
          <>
            <p>
              Acesso Liberado! Baixe o integrador correspondente à versão do sistema operacional.
            </p>

            <div className='down-buttons'>
              <a href='/arquivos/gsa_servico_v1_winXP.zip' download title='Baixar GSA Serviço - XP'>
                <ImWindows size={24} />
                Versão para Windows XP
              </a>

              <a
                href='/arquivos/gsa_servico_v1_win7+.zip'
                download
                title='Baixar GSA Serviço - Win 7+'
              >
                <GrWindows size={24} />
                Versão para Windows 7 ou superior
              </a>

              <a
                href='https://github.com/Henrique-All/my-apks-versions/releases/download/GID/gid-9.0.0.Setup.exe'
                target='_blank'
                rel='noreferrer'
                title='Baixar GID Desktop'
              >
                <img
                  src={Gid}
                  alt='Gid desk icon'
                  style={{ width: 24, height: 24, objectFit: 'contain' }}
                />
                GID Desktop
                <div style={{ display: 'flex', gap: '6px', marginLeft: 'auto' }}>
                  <span className='badge beta'>Beta</span>
                  <span className='badge new'>Novo!</span>
                </div>
              </a>
            </div>
          </>
        )}
      </ModalDownContent>
    </MainModalDown>
  )
}
